<div class="w-100 h-100 d-flex flex-column" style="overflow: auto">
	<div class="container">
		<div class="text-center">
			<img src="assets/img/maintenance.gif" width="400px" height="250px" />
		</div>
		<div class="d-flex flex-column mt-2">
			<div class="maintenanceMessage" [innerHTML]="textFR" *ngIf="textFR"></div>
			<div class="maintenanceMessage" [innerHTML]="textNL" *ngIf="textNL"></div>
			<div class="maintenanceMessage" [innerHTML]="textEN" *ngIf="textEN"></div>
			<div class="maintenanceMessage" [innerHTML]="textDE" *ngIf="textDE"></div>
		</div>
	</div>
</div>
